<template>
  <!-- Wrapper div para mantener la visibilidad solo en móviles -->
  <div class="mobile-nav-only mb-5">
    <!-- Se añaden clases para modo claro/oscuro dinámicamente -->
    <nav class="navbar navbar-expand-lg navbar-light main-navbar" :class="{'bg-light': !isDarkMode, 'navbar-dark bg-dark': isDarkMode}">
      <div class="container-fluid">
        <!-- Logo desde Footer.vue -->
        <a class="navbar-brand" href="#" @click.prevent="showHome">
           <img :src="isDarkMode ? require('@/assets/logoMainNav-dark.webp') : require('@/assets/logoMainNav.webp')"
                alt="Logo" height="50" class="d-inline-block align-top" />
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <!-- Elementos de menú desde Footer.vue -->
          <ul class="navbar-nav me-auto mb-2 mb-lg-0" id="menu">
            <!-- Mostrar Nombre de Usuario (solo en pantallas grandes) -->
            <li class="nav-item px-lg-2 py-2 py-lg-0 d-flex align-items-center">
              <span :class="isDarkMode ? 'text-white' : 'text-dark'" class="fw-bold d-none d-lg-block">{{ displayName }}</span>
            </li>
            <!-- Elemento Inicio -->
            <li class="nav-item">
              <a class="nav-link d-flex align-items-center" @click="showHome" :class="{ selected: selectedItem === 'Home' }"
                 href="#" title="Inicio">
                <span class="material-icons me-2">home</span>
                <span>Inicio</span>
              </a>
            </li>
            <li class="nav-item">
              <a href="#" @click="showPacientes" class="nav-link d-flex align-items-center"
                 :class="{ selected: selectedItem === 'Pacientes' }" title="Pacientes">
                <span class="material-icons me-2">face</span>
                <span>Pacientes</span>
              </a>
            </li>
            <li class="nav-item">
              <a href="#" @click="showMedicamentos" class="nav-link d-flex align-items-center"
                 :class="{ selected: selectedItem === 'Medicamentos' }" title="Herramientas">
                <span class="material-icons me-2">build</span>
                <span>Herramientas</span>
              </a>
            </li>
            <li class="nav-item">
              <a href="#" @click="showMisPaquetes" class="nav-link d-flex align-items-center"
                 :class="{ selected: selectedItem === 'MisPaquetes' }" title="Mis Paquetes">
                <span class="material-icons me-2">inventory</span>
                <span>Mis Paquetes</span>
              </a>
            </li>
             <li class="nav-item">
               <a href="#" @click="showReportes" class="nav-link d-flex align-items-center"
                  :class="{ selected: selectedItem === 'Reportes' }" title="Reportes">
                 <span class="material-icons me-2">bar_chart</span>
                 <span>Reportes</span>
               </a>
             </li>
            <!-- Nuevo elemento Perfil -->
            <li class="nav-item">
              <a href="#" @click="showSettings" class="nav-link d-flex align-items-center"
                 :class="{ selected: selectedItem === 'Settings' }" title="Perfil">
                <span class="material-icons me-2">account_circle</span>
                <span>Perfil</span>
              </a>
            </li>
            <!-- Nuevo elemento Cerrar Sesión -->
            <li class="nav-item">
              <a href="#" @click="logoutUser()" class="nav-link d-flex align-items-center" title="Cerrar Sesión">
                <span class="material-icons me-2">power_settings_new</span>
                <span>Cerrar Sesión</span>
              </a>
            </li>
          </ul>

          <!-- Dropdown de Usuario ELIMINADO -->
          <!-- <div class="dropdown"> ... </div> -->

        </div>
      </div>
    </nav>
  </div>
</template>

<script>
// Importaciones necesarias
import { mapState, mapActions } from "vuex";
import { auth } from "@/fb"; // Asegúrate que fb esté configurado

export default {
  name: 'mainNavbar',
  data() {
    return {
      // Inicializa selectedItem basado en la ruta actual o un valor por defecto
      selectedItem: this.$route.name || "Home",
      user: auth.currentUser || {}, // Inicializa user
      isDarkMode: false // O determina basado en preferencias/sistema
    };
  },
  computed: {
    ...mapState(["displayName"]),
  },
  created() {
    this.$eventBus.$on('lightModeChanged', (isLightMode) => {
        this.isDarkMode = !isLightMode;
      });

    // Listener de estado de autenticación
    this.unsubscribeAuth = auth.onAuthStateChanged((user) => {
      if (user) {
        this.user = user;
        // Llama a la acción de Vuex para actualizar displayName
        this.updateDisplayName(user.displayName || 'Usuario');
      } else {
        this.user = {}; // Limpia datos de usuario
        this.updateDisplayName("--");
      }
    });

    // Listener para actualizaciones de perfil de usuario (ej. cambio de foto)
    // Asume que el evento se emite desde $root o un eventBus
     if (this.$root) {
        this.$root.$on('userUpdated', this.handleUserUpdated);
     }

    // Establecer selectedItem inicial
    this.selectedItem = this.$route.name;

  },
  beforeDestroy() {
    // Limpia listeners
    if (this.$eventBus) {
        this.$eventBus.$off('lightModeChanged');
    }
     if (this.$root) {
        this.$root.$off('userUpdated', this.handleUserUpdated);
     }
    // Cancela la suscripción al listener de autenticación
    if (this.unsubscribeAuth) {
        this.unsubscribeAuth();
    }
  },
  watch: {
    // Actualiza selectedItem cuando cambia la ruta
    $route(to, from) {
      this.selectedItem = to.name;
    },
  },
  methods: {
    // Mapea acciones de Vuex
    ...mapActions(["updateDisplayName"]), // Asegúrate que la acción exista en tu store Vuex
    logoutUser() {
      auth.signOut().then(() => {
        localStorage.removeItem("user"); // O limpia datos de sesión relevantes
        this.$router.push("/"); // Redirige a login o inicio
        // Considera si es necesario recargar o si el estado se limpia correctamente
        // location.reload();
      }).catch(error => {
        console.error("Fallo el cierre de sesión:", error);
        // Maneja el error de cierre de sesión (ej. muestra notificación)
      });
    },
    // Métodos de navegación desde Footer.vue
    showHome() {
      if (this.$route.name !== "Home") {
        this.$router.push({ name: "Home" });
      }
      // selectedItem se actualiza por el watcher
      this.closeNavbar(); // Cierra el menú colapsado si está abierto
    },
    showPacientes() {
      if (this.$route.name !== "Pacientes") {
        this.$router.push({ name: "Pacientes" });
      }
       this.closeNavbar();
    },
    showMedicamentos() {
      if (this.$route.name !== "Medicamentos") {
        this.$router.push({ name: "Medicamentos" });
      }
       this.closeNavbar();
    },
    showMisPaquetes() {
      if (this.$route.name !== "MisPaquetes") {
        this.$router.push({ name: "MisPaquetes" });
      }
       this.closeNavbar();
    },
    showSettings() {
      if (this.$route.name !== "Settings") {
        this.$router.push({ name: "Settings" });
      }
       this.closeNavbar();
    },
    showReportes() {
      if (this.$route.name !== "Reportes") {
        this.$router.push({ name: "Reportes" });
      }
       this.closeNavbar();
    },
    // Maneja actualizaciones de usuario (ej. cambio de foto de perfil)
    handleUserUpdated(updatedUser) {
      console.log('Navbar recibió actualización de usuario:', updatedUser);
      // Actualiza el estado local del usuario, forzando reactividad si es necesario
      this.user = { ...updatedUser };
      // Si el nombre de visualización cambió, actualízalo via Vuex
      if (updatedUser.displayName && updatedUser.displayName !== this.displayName) {
          this.updateDisplayName(updatedUser.displayName);
      }
    },
    // Método para cerrar el menú navbar colapsado (si está abierto)
    closeNavbar() {
        const navbarToggler = this.$el.querySelector('.navbar-toggler');
        const navbarCollapse = this.$el.querySelector('.navbar-collapse');
        // Verifica si el menú está colapsado y visible
        if (navbarCollapse && navbarToggler && getComputedStyle(navbarToggler).display !== 'none' && navbarCollapse.classList.contains('show')) {
            navbarToggler.click(); // Simula un clic en el toggler para cerrarlo
        }
    }
    // Añade otros métodos como showUsers, showFarms, showLogs si son necesarios
  },
}
</script>

<style scoped>
/* Estilos existentes para mostrar/ocultar */
.mobile-nav-only {
  display: none; /* Oculto por defecto */
}

/* Muestra el nav solo en pantallas pequeñas */
@media (max-width: 575.98px) {
  .mobile-nav-only {
    display: block; /* Visible en pantallas pequeñas */
    position: fixed; /* Fijo en la parte superior */
    top: 0;
    left: 0;
    right: 0;
    z-index: 1030; /* Asegura que esté sobre otro contenido */
  }
}

/* Estilos adaptados desde Footer.vue y ajustados para navbar */
.main-navbar {
  /* Estilos base para el fondo del navbar */
   /* Los colores se manejan con :class ahora */
   box-shadow: 0 1px 6px #000000a1; /* Sombra oscura por defecto */
   transition: background-color 0.3s ease; /* Transición suave */
}

/* Estilos para modo claro aplicados via clase en body o wrapper */
body.light-mode .main-navbar {
   background-color: #d5fff6 !important; /* Fondo claro */
   box-shadow: 0 1px 6px #afafaf; /* Sombra clara */
}
body.dark-mode .main-navbar {
    background-color: #212529 !important; /* Fondo oscuro */
    box-shadow: 0 1px 6px #000000a1; /* Sombra oscura */
}


/* Estilos base para enlaces de navegación */
.nav-link {
  color: rgba(255, 255, 255, 0.7); /* Texto oscuro por defecto */
  padding: 0.75rem 1rem; /* Padding consistente */
  margin: 0.1rem 0; /* Margen vertical en modo colapsado */
  border-radius: 0.375rem;
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
  text-decoration: none;
  cursor: pointer;
  display: flex; /* Asegura alineación con icono */
  align-items: center; /* Alinea icono y texto */
  width: 100%; /* Ocupa todo el ancho en modo colapsado */
}

body.light-mode .nav-link {
   color: #333333; /* Texto claro */
}

/* Estado Hover */
.nav-link:hover {
  color: #ffffff; /* Texto hover oscuro */
  background-color: rgba(255, 255, 255, 0.1); /* Fondo hover oscuro */
}

body.light-mode .nav-link:hover {
   color: #000000; /* Texto hover claro */
   background-color: rgba(0, 0, 0, 0.05); /* Fondo hover claro */
}

/* Estado Seleccionado */
.nav-link.selected {
  color: #ffffff; /* Texto seleccionado (ambos modos) */
  background-color: #00eebd63; /* Fondo seleccionado (ambos modos) */
  font-weight: 500;
}
body.light-mode .nav-link.selected {
     color: #ffffff;
}


/* Iconos dentro de enlaces */
.nav-link .material-icons {
  vertical-align: middle;
  margin-right: 0.5rem; /* Espacio entre icono y texto */
}

/* Borde imagen de perfil */
.imagenBorde {
  border: 2px solid #15e35c;
}

/* Ajustes Dropdown */
.dropdown-menu {
   /* Bootstrap maneja los colores dark/light con .dropdown-menu-dark */
}
.dropdown-item {
   /* Ajusta color si es necesario, pero BS5 debería manejarlo */
   display: flex;
   align-items: center;
}
.dropdown-item .material-icons {
    font-size: 1.1em;
    vertical-align: middle;
    margin-right: 0.3rem;
}
.dropdown-item.selected { /* Estilo para item seleccionado en dropdown */
    background-color: #00eebd63;
    color: #ffffff !important; /* Forzar color blanco */
}
body.light-mode .dropdown-menu .dropdown-item {
    color: #212529;
}
body.light-mode .dropdown-menu .dropdown-item:hover,
body.light-mode .dropdown-menu .dropdown-item:focus {
    background-color: #e9ecef;
    color: #000;
}
body.light-mode .dropdown-menu .dropdown-item.selected {
    background-color: #00eebd63;
    color: #ffffff !important; /* Forzar color blanco */
}

/* Ajustes para el menú colapsado */
@media (max-width: 991.98px) { /* Breakpoint lg de Bootstrap donde colapsa */
  .mobile-nav-only {
    /* ... estilos de visibilidad y posicionamiento ... */
     /* Asegúrate que el breakpoint aquí coincida con el de visibilidad si es necesario,
        aunque generalmente el colapso (991.98px) es mayor que la visibilidad móvil (575.98px) */
  }

  .navbar-collapse {
      max-height: calc(100vh - 60px); /* Altura máxima para scroll (ajusta 60px si altura navbar difiere) */
      overflow-y: auto; /* Habilita scroll si el contenido excede */
      width: 100%; /* Asegura que ocupe el ancho */
      align-items: flex-start; /* Alinea items a la izquierda */
  }
  .navbar-nav {
      width: 100%; /* Asegura que la lista ocupe el ancho */
      flex-direction: column !important; /* Fuerza el apilamiento vertical */
  }
  .nav-link {
      width: 100%; /* Asegura que cada enlace ocupe el ancho */
      /* ... otros estilos existentes para nav-link ... */
  }
  .dropdown {
      width: 100%; /* Asegura que el dropdown ocupe el ancho */
      margin-top: 0.5rem; /* Espacio arriba del dropdown */
      padding: 0 1rem; /* Padding horizontal para alinear con nav-links */
  }
  #dropdownUser1 { /* Ajusta el toggle del dropdown */
    justify-content: flex-start; /* Alinea contenido a la izquierda */
    width: 100%;
    padding: 0.75rem 0; /* Padding vertical, sin padding horizontal extra */
  }
  .dropdown-menu {
    width: calc(100% - 2rem); /* Ajusta ancho restando el padding del contenedor */
    margin: 0.125rem 1rem 0; /* Margen superior y horizontal */
    border: none;
    box-shadow: none;
  }
}

/* Color del toggler icon */
body.light-mode .navbar-toggler-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(0, 0, 0, 0.55)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
}
body.dark-mode .navbar-toggler-icon {
   background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(255, 255, 255, 0.55)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
}

</style>
